import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles, Theme, Button } from '@material-ui/core';
import { relative } from 'path';
import { PDFViewer } from '../parts/pdfPreview/PDFViewer';

type Tprops = {
  src: string;
  openPreview: boolean;
  setOpenPreview: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PreviewField: React.FC<Tprops> = (props: Tprops) => {
  const { src, openPreview, setOpenPreview } = props;

  const classes = useStyles();

  return (
    <>
      <div className={classes.paper}>
        <div>
          <Button
            style={{
              width: 63,
              height: 36,
              marginBottom: 10,
              marginLeft: 31,
              color: '#fff',
              backgroundColor: '#52555F'
            }}
            variant='contained'
            onClick={() => setOpenPreview(false)}
          >
            戻る
          </Button>
        </div>
        <PDFViewer src={src} resizeFlg={false} />
      </div>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      // モーダル内部
      backgroundColor: '#f1f1f1',
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '80%',
      maxHeight: '90vh',
      paddingTop: 13,
      paddingBottom: 44,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start'
    }
  })
);
